import { VIEW_MODE_STORAGE_KEY, localStorage } from './constants.tsx';

type ViewModeType = 'MODAL' | 'SIDEBAR' | 'DEFAULT';

export const getViewModeFromLocalStorage = (): ViewModeType => {
	if (__SERVER__) {
		return 'DEFAULT';
	}
	return localStorage.get(VIEW_MODE_STORAGE_KEY) || 'DEFAULT';
};
